import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import {
    Box,
    Button,
    InputAdornment,
    Stack,
    Typography
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import DateRangePickerComponent from "../../components/date/DateRangePickerComponent";
import SearchInput from "../../components/inputs/searchInput";
import useDebounce from "../../hooks/use.debounce";
import { formatPrice, getFormatedDate } from "../../utils/common";
import { getAllBrandForDropDown } from "../brands/action";
import { getExploreCampaignBlockedAmount, getExploreCampaignDetails } from "./action";
import { resetWallet, updateWallet } from "./walletSlice";
import CustomPagination from "../../utils/CustomPagination";
import { styled } from '@mui/material/styles';
import searchIcon from "../../assets/images/icons/searchIcon.svg"

const CustomSearchInput = styled(SearchInput)({
    "& .MuiOutlinedInput-root": {
        borderRadius: "50px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
        borderRadius: "50px !important",
    },
    "& input": {
        padding: '0px !important', paddingLeft: '0px !important'
    }
});

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort, isSticky } = props;
    const createSortHandler =
        (property) => (event) => {
            if (property === "action") {
                return;
            }
            onRequestSort(event, property);
        };

    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Influencer Name",
            type: "",
        },
        {
            id: "company",
            numeric: false,
            disablePadding: true,
            label: "Transaction ID",
            type: "",
        },
        {
            id: "paid",
            numeric: false,
            disablePadding: true,
            label: "Amount",
            type: "",
        },

        {
            id: "platform",
            numeric: false,
            disablePadding: true,
            label: "Date & Time",
            type: "",
        }
    ];

    return (
        <TableHead className={`hideActionSort ${isSticky} `}>
            <TableRow sx={{
                background: '#DBECFF !important', height: "50px", "& th": {
                    backgroundColor: "inherit !important"
                },
            }}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={null}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}


function EnhancedTableHead1(props) {
    const { order, orderBy, onRequestSort, isSticky } = props;
    const createSortHandler =
        (property) => (event) => {
            if (property === "action") {
                return;
            }
            onRequestSort(event, property);
        };

    const headCells = [
        {
            id: "name",
            numeric: false,
            disablePadding: true,
            label: "Influencer Name",
            type: "",
        },
        {
            id: "paid",
            numeric: false,
            disablePadding: true,
            label: "Amount",
            type: "",
        }
    ];

    return (
        <TableHead className={`hideActionSort ${isSticky} `}>
            <TableRow sx={{
                background: '#DBECFF !important', height: "50px", "& th": {
                    backgroundColor: "inherit !important"
                },
            }}>
                {headCells.map((headCell) => {
                    return (
                        <TableCell
                            key={headCell?.id}
                            align={headCell.numeric ? "right" : "left"}
                            padding={headCell.disablePadding ? "none" : "normal"}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : "asc"}
                                IconComponent={null}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === "desc"
                                            ? "sorted descending"
                                            : "sorted ascending"}
                                    </Box>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHead>
    );
}

export default function CampaignWallet() {

    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [tab, setTab] = useState("1");
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {
        limit,
        page,
        sort_key,
        totalPages,
        filters,
        startDate,
        search,
        campaignData,
        exploreCampaignDetails: listing,
        blockedList,
        searchBlocked
    } = useSelector((state) => state.walletSlice);
    const debouncedSearch = useDebounce(search, 500);
    const debouncedSearch1 = useDebounce(searchBlocked, 500);


    const handleRequestSort = (
        event,
        property
    ) => {
        const isAsc = orderBy === property && order === "asc";

        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
        dispatch(
            updateWallet({
                sort_type: isAsc ? "asc" : "desc",
                sort_key: property,
            }),
        );
        dispatch(getAllBrandForDropDown());
    };

    useEffect(() => {
        if (debouncedSearch)
            dispatch(getExploreCampaignDetails(id))
    }, [dispatch, debouncedSearch, id]);

    useEffect(() => {
        if (debouncedSearch1)
            dispatch(getExploreCampaignBlockedAmount(id))
    }, [dispatch, debouncedSearch1, id]);

    useEffect(() => {
        dispatch(getExploreCampaignDetails(id));
        dispatch(getExploreCampaignBlockedAmount(id))
        return () => dispatch(resetWallet())
    }, []);

    const handleSearch = (event) => {
        if (event.target.value) {
            dispatch(updateWallet({ search: event.target.value }));
        } else {
            dispatch(updateWallet({ search: "" }));
            dispatch(getExploreCampaignDetails(id))
        }
    };

    const handleSearch1 = (event) => {
        if (event.target.value) {
            dispatch(updateWallet({ searchBlocked: event.target.value }));
        } else {
            dispatch(updateWallet({ searchBlocked: "" }));
            dispatch(getExploreCampaignBlockedAmount(id))
        }
    };

    const handleChange = (value) => {
        dispatch(updateWallet({ page: value - 1 }));
        dispatch(getExploreCampaignDetails(id));
    };
    const handleSearchClear = () => {
        dispatch(updateWallet({ filters: { ...filters, name: "" } }));
        dispatch(getExploreCampaignDetails(id));
    };

    let dataFilter = startDate ? { startDate: startDate } : {};
    return (
        <>
            <Box sx={{ padding: '16px' }}>
                <Stack direction="row" alignItems="left" mb={2}>
                    <Typography className="page-title capitalize-first-letter" variant="h1"> {campaignData?.name}</Typography>
                    <Stack
                        className="backText"
                        direction={"row"}
                        alignItems={"left"}
                        sx={{ cursor: "pointer" }}
                        onClick={() => navigate("/wallet")}
                    >
                        <Typography variant="h5" mt={0.5} color={"primary"}>
                            <svg
                                width="16"
                                height="12"
                                viewBox="0 0 16 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.5 7.66667L5.16667 4.33333L8.5 1M4.33333 7.66667L1 4.33333L4.33333 1"
                                    stroke="#0077FF"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                                <path
                                    d="M5.1665 4.33331H10.9998C11.8839 4.33331 12.7317 4.6845 13.3569 5.30962C13.982 5.93474 14.3332 6.78259 14.3332 7.66665C14.3332 8.5507 13.982 9.39855 13.3569 10.0237C12.7317 10.6488 11.8839 11 10.9998 11H10.1665"
                                    stroke="#0077FF"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg> Back
                        </Typography>
                    </Stack>
                </Stack>

                <Stack direction={"row"} gap={2}>
                    <div className="viewAmtBlcks" style={{ width: '100%' }}>
                        <div className="amtblckItem estimatePayout">
                            <div><h4>&#x20B9;{formatPrice(campaignData?.budget) || 0}</h4>
                                <p className="walletSubHeadings">Campaign Budget</p>
                            </div>
                        </div>
                        <div className="amtblckItem creatorLive">
                            <div>
                                <h4>&#x20B9;{formatPrice(campaignData?.remainingBudget) || 0}</h4>
                                <p className="walletSubHeadings">Remaining Budget</p>
                            </div>
                        </div>
                    </div>
                </Stack>
                <Stack direction="column" gap={0} sx={{ marginTop: '20px' }}>
                    <Typography variant="h4" sx={{paddingBottom:{xs:'1rem',sm:'0'}}}>Payment History</Typography>
                    <Stack direction={{sm:"row",xs:"column"}} justifyContent={{sm:"space-between",xs:"flex-start"}} alignItems={{sm:"center",xs:"flex-start"}}>
                        <Stack direction="row"  gap={2}>
                            <Button onClick={() => setTab("1")} sx={{
                                height: '40px', width: '145px', borderRadius: '5px', border: `1px solid ${tab === "1" ? "var(--color-blue)" : "#F0F0F0"}`, fontSize: '14px', fontWeight: '400', color: `${tab === "1" ? "white" : 'black'}`, background: `${tab === '1' ? "var(--color-blue)" : 'white'}`, "&:hover": {
                                    background: "var(--color-blue)", border: '1px solid var(--color-blue)', color: 'white'
                                }
                            }}>
                                Payment History
                            </Button>
                            <Button onClick={() => setTab("2")} sx={{
                                height: '40px', width: '145px', borderRadius: '5px', border: `1px solid ${tab === "2" ? "var(--color-blue)" : "#F0F0F0"}`, fontSize: '14px', fontWeight: '400', color: `${tab === "2" ? "white" : 'black'}`, background: `${tab === '2' ? "var(--color-blue)" : 'white'}`, "&:hover": {
                                    background: "var(--color-blue)", border: '1px solid var(--color-blue)', color: 'white'
                                }
                            }}>
                                Blocked Amount
                            </Button>
                        </Stack>
                        <Stack direction="row" gap={2}>
                            {tab === "1" && <>
                                <Box className="myCmpny d-flex flex-wrap align-items-center justify-content-end searcFilter" sx={{padding:{sm:'1rem',xs:'0'},paddingY:{xs:'1rem'}}}>
                                    <div className='allFilter walletDateRange  '>
                                        <div className="d-flex flex-wrap  gap-1" >
                                            <Box  sx={{background:'white',borderRadius:'10px',marginRight:{lg:'15px',sm:'0'},width:'40%',}}>
                                                <DateRangePickerComponent text="Date Range" getSelectedDate={(dates) => {
                                                    if (dates?.filter((v) => v)?.length === 2) {
                                                        dispatch(updateWallet({ startDate: getFormatedDate(dates[0]), endDate: getFormatedDate(dates[1]) }));
                                                        dispatch(getExploreCampaignDetails(id));
                                                    }
                                                }} dateReset={dataFilter} />
                                            </Box>
                                            <CustomSearchInput
                                                className="inputSearch sContrl p-0 "
                                                value={search}
                                                sx={{
                                                    width:{lg:'250px',xs:'200px'}
                                                }}
                                                placeholder={"Search here..."}
                                                handleSearch={handleSearch}
                                                clearSearch={handleSearchClear}
                                                startAdornment={
                                                    <InputAdornment className="overIcon" position="start"
                                                        sx={{
                                                            maxHeight: 'none',
                                                            height: '38px',
                                                            minWidth: '38px',
                                                            marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                                        }}
                                                    >
                                                        <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                                    </InputAdornment>
                                                }
                                            />
                                            <RotateLeftIcon toolTip="Refresh page" size="small" sx={{ cursor: "pointer", color: '#6C7692', position: "relative", top: "10px" }}
                                                onClick={() => {
                                                    dispatch(updateWallet({ startDate: "", endDate: "" }));
                                                    dispatch(getExploreCampaignDetails(id));
                                                }} />
                                        </div></div></Box>
                            </>}
                            {tab === "2" &&
                                <div className="myCmpny d-flex flex-wrap align-items-center justify-content-end searcFilter py-3">
                                    <div className='allFilter walletDateRange '>
                                        <div className="d-flex flex-wrap  gap-1" >
                                            <CustomSearchInput
                                                className="inputSearch sContrl p-0"
                                                value={searchBlocked}
                                                placeholder={"Search here..."}
                                                handleSearch={handleSearch1}
                                                clearSearch={handleSearchClear}
                                                sx={{
                                                    width:{lg:'250px',xs:'200px'}
                                                }}
                                                startAdornment={
                                                    <InputAdornment className="overIcon" position="start"
                                                        sx={{
                                                            maxHeight: 'none',
                                                            height: '38px',
                                                            minWidth: '38px',
                                                            marginRight: '0px', background: 'none !important', borderRadius: '50px !important'
                                                        }}
                                                    >
                                                        <img src={searchIcon} height={20} width={20} alt="" srcset="" />
                                                    </InputAdornment>
                                                }
                                            />
                                        </div></div></div>}
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
            {tab === "1" && <>
                <TableContainer sx={{ maxHeight: '75vh' }} >
                    <Table stickyHeader aria-label="sticky table">
                        <EnhancedTableHead
                            order={order}
                            orderBy={sort_key}
                            onRequestSort={handleRequestSort}
                            numSelected={0}
                            onSelectAllClick={function (
                            ) {
                                throw new Error("Function not implemented.");
                            }}
                        />
                        <TableBody>
                            {listing && listing?.length ? (
                                listing?.map((row) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row?.id}
                                            className={"tableRow"}
                                            sx={{
                                                "&:hover": {
                                                    backgroundColor: '#F0F7FF !important', "& td": {
                                                        backgroundColor: "inherit !important"
                                                    },
                                                }, height:'60px'
                                            }}>
                                            <TableCell component="td" scope="row">
                                                {row?.name || "N/A"}

                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                {row?.txId || "N/A"}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <div className="paymentDue">
                                                    ₹{formatPrice(row?.totalAmount) || "N/A"}
                                                </div>
                                            </TableCell>
                                            <TableCell align="left">
                                                {row?.createdAt ? getFormatedDate(row?.createdAt, "DD MMMM YYYY hh:mm A") : "N/A"}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow colSpan={10}>
                                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>

                                        <Typography
                                            color="inherit"
                                            variant="subtitle1"
                                            alignItems={"center"}
                                            component="h3">
                                            No Data found!
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>

                </TableContainer>
                <Stack
                    sx={{
                        background: 'transparent',
                        height: '60px',
                        border: '1px solid #E9EAEB'
                    }}
                    direction="row"
                    alignItems={"center"}
                    justifyContent={"flex-end"}
                >
                    <CustomPagination
                        count={Math.ceil(totalPages / limit) || 0}
                        onChange={handleChange}
                        currentPage={page}
                        defaultPage={1} siblingCount={1} boundaryCount={1} />
                </Stack >
            </>}
            {tab === "2" && <>
                <TableContainer sx={{ maxHeight: '75vh' }} >
                    <Table
                        stickyHeader aria-label="sticky table"
                    >
                        <EnhancedTableHead1
                            order={order}
                            orderBy={sort_key}
                            onRequestSort={handleRequestSort}
                            numSelected={0}
                            onSelectAllClick={function (
                            ) {
                                throw new Error("Function not implemented.");
                            }}
                        />
                        <TableBody>
                            {blockedList && blockedList?.length ? (
                                blockedList?.map((row) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row?.id}
                                            className={"tableRow"}
                                            sx={{
                                                "&:hover": {
                                                    backgroundColor: '#F0F7FF !important', "& td": {
                                                        backgroundColor: "inherit !important"
                                                    },
                                                }, height:'60px'
                                            }}>
                                            <TableCell component="td" scope="row">
                                                {row?.name || "N/A"}
                                            </TableCell>
                                            <TableCell component="td" scope="row">
                                                <div className="paymentDue">
                                                    ₹{formatPrice(row?.totalAmount) || "N/A"}
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    );
                                })
                            ) : (
                                <TableRow colSpan={10}>
                                    <TableCell colSpan={10} style={{ textAlign: 'center' }}>
                                        <Typography
                                            color="inherit"
                                            variant="subtitle1"
                                            alignItems={"center"}
                                            component="h3">
                                            No Data found!
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </>}
        </>
    );
}
